// src/components/feature/NavBar.tsx
import React from "react";

const Footer: React.FC = () => {
  return <div className="h-64 w-full"></div>;
};

export default Footer;
